import VueRouter from 'vue-router';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Store } from 'vuex';
import { IState } from '@/store/namespace';

/**
 * Имя заголовка аутентификации
 */
export const authHeader = 'AuthorizationToken';

/* демонстрация  http://e-co.incom.tomsk.ru */
/* разработка  http://localhost:8081 */
/**
 * Базовый адрес
 */
//export const domenUrl = 'http://localhost:8081';
export const domenUrl = '';

/**
 * Интерфейс сервиса доступа к api
 */
export interface IHttpService extends AxiosInstance {
    store?: Store<IState>;
    router?: VueRouter;
    isReAuthenticating?: boolean;
    pendingRequests?: any[];
}

/**
 * Сервис доступа к api (посредством http запросов)
 */
export let HttpService: IHttpService = axios.create();

/**
 * Метод инциализации http сервиса
 * @param store центральное хранилище Vuex
 * @param router роутер приложения
 */
export const initHttpService = (store?: Store<IState>, router?: VueRouter) => {
    /* istanbul ignore next */
    HttpService = axios.create({
        baseURL: domenUrl + `/api`,
    });

    // попытаемся извлеч токен из локального хранилища
    const token: string = localStorage.getItem('user-token') || '';

    // если токен есть - добавим его в http запрос по умолчанию
    // если его нет - очистим заголовок по умолчанию
    if (token !== '' && token !== undefined) {
        HttpService.defaults.headers.common[authHeader] = token;
    } else {
        delete HttpService.defaults.headers.common[authHeader];
    }

    HttpService.defaults.headers.common['Content-Type'] = 'application/json';

    HttpService.store = store;
    HttpService.router = router;
    HttpService.isReAuthenticating = false;
    HttpService.pendingRequests = [];
    
};

/**
 * Метод для подмены старого токена
 * @param request 
 * @param accessToken 
 */
export const replaceOldToken = (request: AxiosRequestConfig, accessToken: string): AxiosRequestConfig => {
    request.headers[authHeader] = `${accessToken}`;
    return request;
};
